module.exports = __webpack_public_path__ + "media/src/images/icons/flags/switzerland-7023056dc0c710a8da1cea278ef7ee25.svg";